import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors, Hidden, Paper, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import DiscountPermissions from "../discount-permissions";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { useStylesLbl, useStylesTF } from "../../../../St/comps/UseStyle";
import POSPermissions from "./POS-permissions";
import { SharedGroupIdProvider } from "../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import GroupLists from "../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { ProductsGroups } from "../../../Invs/BackEnd/POS/ProductsGroups";
import { GroupSelectRest } from "../../../Invs/BackEnd/POS/GroupSelectRest";
import ShiftsPermission from "./ShiftsPermission";
import { billPrintType, cashirPrintType } from "../../PrintCasher";
import { useTranslation } from "react-i18next";
const formData = [
  { name: "Automatic_Insert", label: "automatic-entry", visible: true },
  { name: "ShowQtyScreen", label: "hide-quantity-screen", visible: false },
  {
    name: "UpdateSalePrice",
    label: "allow-edit-sale-price",
    visible: true,
  },
  {
    name: "sale_no_less_than_purch",
    label: "prevent-sale-price-below-purchase-price",
    visible: true,
  },
  {
    name: "sale_no_less_than_minPrice",
    label: "prevent-sale-price-below-min-price",
    visible: true,
  },
  {
    name: "UpdateSaleDate",
    label: "allow-edit-sale-invoice-date",
    visible: true,
  },
  {
    name: "SaleInMinus",
    label: "allow-sale-without-stock-quantity",
    visible: true,
  },
  {
    name: "saleVatUpdate",
    label: "allow-edit-tax-on-sale",
    visible: true,
  },
  {
    name: "allow_salePrice_zero",
    label: "allow-zero-sale-price-as-bonus",
    visible: true,
  },
  {
    name: "allow_return_Without_bill",
    label: "allow-return-without-invoice",
    visible: true,
  },
  {
    name: "allow_replace_Without_bill",
    label: "allow-replace-without-invoice",
    visible: true,
  },
  {
    name: "inv_post_unlock",
    label: "allow-edit-delete-posted-invoice",
    visible: false,
  },
  {
    // this field for users table
    name: "register_customer_no_account",
    label: "allow-customer-without-account",
    visible: true,
  },
  {
    name: "allow_discount",
    label: "allow-discount",
    visible: true
  },
  {
    name: "PrintAfter_Save",
    label: "print-invoice-after-save",
    visible: true,
  },
  {
    name: "Purch_out_goods",
    label: "print-goods-exit-permit",
    visible: true,
  },
  {
    name: "NoRepeatItem",
    label: "disable-item-grouping",
    visible: true,
  },
  {
    name: "use_barcode_reader",
    label: "use-barcode-reader",
    visible: true,
  },
  {
    name: "Cust_SalePrice",
    label: "approve-last-customer-sale-price",
    visible: true,
  },
  {
    name: "ShowBtnCar",
    label: "show-car-specifications",
    visible: true,
  },
  {
    name: "return_same_invoice_date",
    label: "return-invoice-same-sale-date",
    visible: true,
  },
  {
    name: "hide_item_data",
    label: "hide-add-item-button",
    visible: true,
  },
  {
    name: "hide_item_info",
    label: "hide-item-info",
    visible: true,
  },

  // { name: "allow_discount", label: "allow-discount", visible: true },
];

export default function SalePermissions(props) {
  const { onChange, object, update, gData, accounts } = props;
  const { t } = useTranslation(["forms"]);
  const typeSetting = [
    { id: 0, name: t("sales-settings"), color: -1 },
    { id: 1, name: t("pos-settings"), color: -1 },
    { id: 2, name: t("shift-settings"), color: -1 },
  ];

  const classes = useStylesAcc();
  const [saleSetting, setSaleSetting] = useState(typeSetting[0]);
  const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });

  const typSystem = [
    { id: 1, name: t("enable-invoice-screen") },
    { id: 3, name: t("enable-restaurant-screen") },
    { id: 4, name: t("enable-station-screen") },
    { id: 5, name: t("enable-laundry-screen") },
    { id: 6, name: t("enable-invoice-screen-2") },
    { id: 7, name: t("enable-restaurant-screen-plus") },
  ];
  const valueType = GetItemFromOptions(object?.invtype ?? 1, typSystem);
  const valuelargePrinter = GetItemFromOptions(parseInt(object?.largePrinter ?? 1) ?? 1, billPrintType);
  const valuesmallPrinter = GetItemFromOptions(parseInt(object?.smallPrinter ?? 1) ?? 1, cashirPrintType);


  const typePrices = [
    { id: 0, name: t("retail") },
    { id: 1, name: t("distributor") },
    { id: 2, name: t("wholesale") },
  ];
  const valuePrice = GetItemFromOptions(object?.type_sale_price ?? 1, typePrices);

  const clasTF = useStylesTF();
  const claslbl = useStylesLbl();
  const onRowClick = (row) => {
    setSaleSetting(row);
    setSelectColor({ ...row, color: colors.blue[300] });
  };
  return (
    <div className={classes.root}>
      <Accordion expanded={true}>

        <Grid item xs={12} container spacing={0} >

          <Grid item lg={2} md={2} sm={12} xs={12}>
            <Hidden smDown>
              <Paper
                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
              >
                <SharedGroupIdProvider>
                  <GroupLists
                    groups={[...typeSetting]}
                    onRowClick={onRowClick}
                    isMain={true}
                    GroupColor={selectColor}
                  />
                  <Divider />
                </SharedGroupIdProvider>
              </Paper>
            </Hidden>
            <Hidden mdUp>
              <GroupSelectRest
                groups={[...typeSetting]}
                onRowClick={onRowClick}
                isMain={true}
                GroupColor={selectColor}
              />
            </Hidden>
          </Grid>

          <Grid item lg={10} md={10} sm={12} xs={12}>
            <div
              style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
            >
              <SharedGroupIdProvider>
                {saleSetting.id == 0 ?
                  <>
                    <AccordionDetails className={classes.subTitle}>
                    </AccordionDetails>

                    <AccordionDetails >
                      <Grid item container spacing={1}>
                        {formData
                          ?.filter((d) => d.visible)
                          ?.map((item) => {
                            return (
                              <Grid xs={6}>
                                <CheckboxItem
                                  value={object[item.name] ?? null}
                                  name={item.name}
                                  label={t(item.label)}
                                  onChange={onChange}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </AccordionDetails>
                    <Grid container lg={12} md={12} sm={12} xs={12} spacing={1}>

                      <Grid item xs={6} lg={4} md={4} sm={6}>
                        <Autocomplete
                          value={valueType}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "invtype",
                              value: newValue?.id,
                            });
                          }}
                          id="apply_discount"
                          size="small"
                          options={typSystem}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label={t("system-type")}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={6} lg={4} md={4} sm={6}>
                        <Autocomplete
                          value={valuePrice}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "type_sale_price",
                              value: newValue?.id,
                            });
                          }}
                          id="type_sale_price"
                          size="small"
                          options={typePrices}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label={t("default-sale-price")}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item lg={4} md={4} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                          id="No_Digit_Round"
                          label={t("copy-print-number")}
                          type="number"
                          className={clasTF.rootCust}
                          InputLabelProps={{ className: claslbl.clrBlackLblS }}
                          name="no_copies"
                          value={object.no_copies}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "no_copies",
                              value: event.target.value,
                            });
                          }}
                        />
                      </Grid>
                      <Grid item xs={4} lg={4} md={6} sm={6}>
                        <Autocomplete
                          value={valuelargePrinter}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "largePrinter",
                              value: newValue?.id,
                            });
                          }}
                          id="apply_discount"
                          size="small"
                          options={billPrintType}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : t(option.name)
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label={t("a4-print-template")}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={4} lg={4} md={6} sm={6}>
                        <Autocomplete
                          value={valuesmallPrinter}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "smallPrinter",
                              value: newValue?.id,
                            });
                          }}
                          id="apply_discount"
                          size="small"
                          options={cashirPrintType}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : t(option.name)
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label={t("cashier-print-template")}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                    <AccordionDetails>
                      {" "}
                      <Typography>{t("sales-discount-settings")}
                      </Typography>{" "}
                    </AccordionDetails>
                    <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>
                      {object?.allow_discount ? <DiscountPermissions {...props} /> :
                        <Typography variant="h5" style={{ textAlign: "center" }}>
                          {"\n "}{t("enable-discount-first-warning")}

                        </Typography>}
                    </AccordionDetails>
                    <Divider className={classes.divider} />
                  </>
                  : saleSetting.id == 1 ?
                    <POSPermissions
                      object={object}
                      onChange={onChange}
                      update={update}
                      gData={gData}
                    /> :
                    <ShiftsPermission   {...{ onChange, object, accounts }} />
                }

              </SharedGroupIdProvider>
            </div>
          </Grid>
        </Grid>

        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {t("save-changes")}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
